module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('titles.forgottenPassword')
    }
  }, [(!_vm.sent) ? [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.$t('forgotten.description')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('headers.username'),
      "required": true
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "loading": _vm.isBusy,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('forgotten.send')))])], 1)], 1)] : [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t('forgotten.success')))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c417f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ForgottenPassword.vue
// module id = 1066
// module chunks = 1